export default (html: string) => `export default ${html}`
